<div class="sum-items-container">

    <div class="subtraction-selection">
        <div class="custom-dropdown" data-testid="calculation-items-dropdown" (click)="toggleXDropdown()">
            <span *ngIf="xItem == null">Select the X Item</span>
            <span *ngIf="xItem != null">1 Item Selected</span>
            <span class="ham-icon">
                <i class="chevron-down-icon"></i>
            </span>
        </div>

        <span class="subtraction-icon"> - </span>

        <div class="custom-dropdown" (click)="toggleYDropdown()">
            <span *ngIf="yItem == null">Select the Y Item</span>
            <span *ngIf="yItem != null">1 Item Selected</span>
            <span class="ham-icon">
                <i class="chevron-down-icon"></i>
            </span>
        </div>
    </div>

    <div class="dropdowns-container">
        <div class="dropdown-options">
            <ng-container *ngIf="xDropdownOpen">
                <div *ngFor="let item of selectionOptions" class="dropdown-item" (click)="onSelectXItem(item)">
                    <span class="selection-col caption">
                        <!-- Selection Checkbox -->
                        <span hamCheckbox [checked]="xItem?.name === item.name" (change)="onSelectXItem(item)"></span>

                        <span
                            class="text"
                            data-testid="calculation-item-label"
                            [hamTooltip]="item.caption"
                            [tooltipOnlyWhenTruncated]="true"
                            [tooltipAboveModals]="true"
                        >
                            {{ item.caption }}
                        </span>
                    </span>
                    <span class="selection-col current-year">{{ item.currentValue | finNumber }}</span>
                    <span class="selection-col previous-year">{{ item.previousValue | finNumber }}</span>
                </div>
            </ng-container>
        </div>
        <span class="empty-span"> </span>
        <div class="dropdown-options">
            <ng-container *ngIf="yDropdownOpen">
                <div *ngFor="let item of selectionOptions" class="dropdown-item" (click)="onSelectYItem(item)">
                    <span class="selection-col caption">
                        <!-- Selection Checkbox -->
                        <span hamCheckbox [checked]="yItem?.name === item.name" (change)="onSelectYItem(item)"></span>

                        <span
                            class="text"
                            data-testid="calculation-item-label"
                            [hamTooltip]="item.caption"
                            [tooltipOnlyWhenTruncated]="true"
                            [tooltipAboveModals]="true"
                        >
                            {{ item.caption }}
                        </span>
                    </span>
                    <span class="selection-col current-year">{{ item.currentValue | finNumber }}</span>
                    <span class="selection-col previous-year">{{ item.previousValue | finNumber }}</span>
                </div>
            </ng-container>
        </div>
        <span class="empty-span"> </span>
    </div>
    <div class="chips-container">
        <div *ngIf="!xDropdownOpen && xItem" class="selected-items">
            <span class="chip"> {{ xItem.caption }} <span class="remove-icon" (click)="removeXItem()">×</span> </span>
        </div>
        <span class="empty-span"> </span>
        <div *ngIf="!yDropdownOpen && yItem" class="selected-items">
            <span class="chip"> {{ yItem.caption }} <span class="remove-icon" (click)="removeYItem()">×</span> </span>
        </div>
        <span class="empty-span"> </span>
    </div>
</div>
